import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbGlobalPhysicalPosition, NbTabsetComponent } from '@nebular/theme';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EHSService } from '../ehs-micro-indicador.service';
import { saveAs } from 'file-saver';
import { UserService } from '../../user/user.service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { EHSExternalService } from '../ehs-micro-indicador-external.service';
import { ResultImportComponent } from '../../result-import/result-import.component';


@Component({
    selector: 'ngx-import-external-ehs-micro-indicador',
    templateUrl: 'import-external.component.html',
    styleUrls: ['import-external.component.scss'],
})
export class ImportExternalComponent implements OnInit {

    public parentId = '';
    ehsMicroIndicador: any = {};
    registerForm: FormGroup;
    submitted = false;
    public file: any = {};
    records;
    dateInitSelected;
    dateFinishSelected;

    tabs;
    tabActived = '';

    constructor(private ehsService: EHSService, private route: ActivatedRoute,
        private toastrService: NbToastrService, private router: Router, private formBuilder: FormBuilder,
        private userService: UserService, private localeService: BsLocaleService,
        private eHSExternalService: EHSExternalService) {
        this.parentId = this.route.snapshot.params.parentId;
        this.localeService.use('pt-br');

        this.get();
    }

    get() {
        this.tabs = [];
        this.eHSExternalService.find(this.parentId).toPromise().then(reuslt => {
            const response = reuslt.body;
            for (let i = 0; i < response.length; i++) {
                const r = response[i];

                const pattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
                let dt = null;
                if (r.finishValidity) {
                    const arrayFinishValidity = r.finishValidity.match(pattern);
                    dt = new Date(arrayFinishValidity[3], arrayFinishValidity[2] - 1, arrayFinishValidity[1]);
                }
                const arrayInitiationValidity = r.initiationValidity.match(pattern);
                const dt1 = new Date(arrayInitiationValidity[3], arrayInitiationValidity[2] - 1,
                    arrayInitiationValidity[1]);

                this.tabs.push({
                    id: r.id, title: r.title, active: false, users: r.users,
                    dateFinishSelected: dt, dateInitSelected: dt1,
                    titleDesc: r.title + ' (' + r.initiationValidity + ')',
                });
            }

            this.tabs.push({
                active: true, users: [],
                titleDesc: 'Nova',
            });
            this.tabActived = 'NOVA';
        });
    }

    ngOnInit() {
        this.registerForm = this.formBuilder.group({
            name: ['', Validators.required]
        });
    }

    public changeListener(files: FileList, tab) {
        if (files && files.length > 0) {
            const file: File = files.item(0);
            this.file = file;
            this.previewImport(tab);
        }
    }

    previewImport(tab) {
        const formData = new FormData();
        formData.append('file', this.file);
        formData.append('micro_indicador_id', this.parentId);
        this.ehsService.previewImport(formData).toPromise().then(result => {
            tab.users = result.body;
        });
    }

    modelChanged(event, tab) {
        tab.dateFinishSelected = event;
    }

    modelChangedInit(event, tab) {
        tab.dateInitSelected = event;
    }

    downloadExample(type: string) {
        this.userService.downloadExampleEHS(type, this.parentId).toPromise().then(response => {
            saveAs(response.body, `planilha_ehs_4persons.${type}`);
        });
    }

    onSubmit() {
        this.submitted = true;

        if (this.registerForm.invalid) {
            return;
        }
    }

    goBack() {
        this.router.navigate(['pages/admin/ehs-micro-indicador']);
    }

    convertDate(tab) {
        if (tab.dateInitSelected) {
            const datestring = tab.dateInitSelected.getDate() + '/' + (tab.dateInitSelected.getMonth() + 1) + '/'
                + tab.dateInitSelected.getFullYear();
            tab.initiationValidity = datestring;
        } else {
            tab.initiationValidity = this.dateInitSelected;
        }

        if (tab.dateFinishSelected) {
            const datestring = tab.dateFinishSelected.getDate() + '/' + (tab.dateFinishSelected.getMonth() + 1) + '/'
                + tab.dateFinishSelected.getFullYear();
            tab.finishValidity = datestring;
        } else {
            tab.finishValidity = this.dateFinishSelected;
        }
    }

    selectTab(event) {
        this.tabActived = event.tabTitle;
    }

    valid(tab) {
        if (!tab) {
            this.validErrorMessage('Preencha todos os campos');
            return false;
        } else {
            if (!tab.initiationValidity) {
                this.validErrorMessage('Preecha o campo início vigência');
                return false;
            }
            if (tab.users.length === 0) {
                this.validErrorMessage('Nenhuma planilha importada');
                return false;
            } else {
                for (let i = 0; i < tab.users.length; i++) {
                    const element = tab.users[i];
                    if (element.weightMax < Number(element.value)) {
                        this.validErrorMessage('Usuário ' + element.name + ' está com o valor superior ao peso máximo');
                        return false;
                    }
                }
            }
        }

        return true;
    }

    validErrorMessage(message) {
        this.toastrService.show('Importação', message,
            { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    }

    save() {
        let tab: any = {};
        for (let i = 0; i < this.tabs.length; i++) {
            const tabObj = this.tabs[i];
            if (tabObj.titleDesc.toLowerCase() === this.tabActived.toLowerCase()) {
                tab = tabObj;
            }
        }
        this.convertDate(tab);
        tab.microIndicadorId = this.parentId;

        if (!this.valid(tab)) {
            return;
        }
        this.eHSExternalService.create(tab).toPromise().then(result => {
            this.toastrService.show('EHS', 'Importado com sucesso!',
                { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
            this.goBack();
        }).catch(err => {
            this.toastrService.show('EHS', err.error.message,
                { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
        });
    }

}
